/* cl-interactive: comportamento das secoes copiadas do Fabric (o scope remove todo <script>
   e os custom elements viram cl-*, sem construtor). */
(function(){
  var SEC = '[class*="cl-sec-"], .cl-pdp';

  /* accordion-custom do Fabric: abre/fecha por viewport (open-by-default-on-desktop/-mobile)
     e fica travado aberto onde data-disable-on-{desktop,mobile} estiver presente */
  function accState(){
    var desk = window.innerWidth >= 750;
    document.querySelectorAll('cl-accordion-custom').forEach(function(a){
      var d = a.querySelector('details'); if (!d) return;
      var want = desk ? a.hasAttribute('open-by-default-on-desktop') : a.hasAttribute('open-by-default-on-mobile');
      if (a.__clVp !== desk) { a.__clVp = desk; d.open = want; }
    });
  }
  document.addEventListener('click', function(e){
    var s = e.target && e.target.closest && e.target.closest('cl-accordion-custom summary');
    if (!s) return;
    var a = s.closest('cl-accordion-custom');
    var locked = window.innerWidth >= 750 ? a.hasAttribute('data-disable-on-desktop') : a.hasAttribute('data-disable-on-mobile');
    if (locked) e.preventDefault();
  }, true);

  /* slideshow do Fabric (resource-list e galeria do card): setas rolam o scroller 1 slide */
  function initSlideshow(ss){
    if (ss.__cl) return; ss.__cl = true;
    var sc = ss.querySelector(':scope > cl-slideshow-container > cl-slideshow-slides, :scope cl-slideshow-slides');
    if (!sc) return;
    var arrows = ss.querySelector(':scope > cl-slideshow-container > cl-slideshow-arrows') || ss.querySelector('cl-slideshow-arrows');
    if (!arrows || arrows.closest('cl-slideshow-component') !== ss) return;
    var prev = arrows.querySelector('.slideshow-control--previous'), next = arrows.querySelector('.slideshow-control--next');
    function slides(){ return [].slice.call(sc.children).filter(function(c){ return c.tagName === 'CL-SLIDESHOW-SLIDE'; }); }
    function step(){ var s = slides(); return s[0] ? s[0].getBoundingClientRect().width : sc.clientWidth; }
    function upd(){
      var max = sc.scrollWidth - sc.clientWidth - 2;
      if (prev) { if (sc.scrollLeft <= 1 && !ss.hasAttribute('infinite')) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled'); }
      if (next) { if (sc.scrollLeft >= max && !ss.hasAttribute('infinite')) next.setAttribute('disabled', ''); else next.removeAttribute('disabled'); }
      var s = slides(), i = Math.round(sc.scrollLeft / (step() || 1));
      s.forEach(function(x, k){ x.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function go(dir){
      var max = sc.scrollWidth - sc.clientWidth;
      var to = sc.scrollLeft + dir * step();
      if (ss.hasAttribute('infinite')) { if (to > max + 1) to = 0; if (to < -1) to = max; }
      sc.scrollTo({left: Math.max(0, Math.min(max, to)), behavior: 'auto'});
      upd();
    }
    if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(-1); });
    if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(1); });
    sc.addEventListener('scroll', upd, {passive: true});
    upd();
  }


  /* overflow-list das swatches do card: uma linha so, o resto vira "+N" (o Fabric faz isso no JS
     do custom element; a copia mostrava todas as bolinhas em 2 linhas) */
  function fitSwatches(){
    document.querySelectorAll('cl-product-swatches cl-overflow-list').forEach(function(ol){
      if (!ol.closest(SEC)) return;
      var items = [].slice.call(ol.children).filter(function(c){ return c.tagName === 'LI' && c.getAttribute('slot') !== 'more'; });
      var more = ol.querySelector(':scope > li[slot="more"]');
      items.forEach(function(li){ li.style.display = ''; });
      if (more) more.style.display = 'none';
      ol.style.flexWrap = 'nowrap';
      var W = ol.clientWidth, gap = parseFloat(getComputedStyle(ol).columnGap) || 0, used = 0, hidden = 0;
      var ws = items.map(function(li){ return li.getBoundingClientRect().width; });
      var total = ws.reduce(function(a, b){ return a + b; }, 0) + gap * Math.max(0, ws.length - 1);
      if (total <= W + 0.5) return;
      var moreW = 16;
      if (more) { more.style.display = 'flex'; ol.style.setProperty('--overflow-count', 9); moreW = more.getBoundingClientRect().width || 16; more.style.display = 'none'; }
      for (var i = 0; i < items.length; i++) {
        var need = used + (i ? gap : 0) + ws[i];
        if (need + gap + moreW > W) { items[i].style.display = 'none'; hidden++; }
        else used = need;
      }
      if (more && hidden) { more.style.display = 'flex'; ol.style.setProperty('--overflow-count', hidden); }
    });
  }

  /* --header-group-height: o Horizon do concorrente mede anuncio+header por JS (measureHeaderHeights)
     e o hero da home usa calc(100svh - var(--header-group-height)). Mesma medicao sobre o
     header-group do Shrine. */
  function measureHeader(){
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(s){
      if (getComputedStyle(s).display !== 'none') h += s.getBoundingClientRect().height;
    });
    document.body.style.setProperty('--header-group-height', Math.round(h) + 'px');
  }
  function watchHeader(){
    measureHeader();
    if (!window.ResizeObserver) return;
    var ro = new ResizeObserver(measureHeader);
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(s){ ro.observe(s); });
  }

  /* hero da home nova (<slideshow-component autoplay="6"> do Horizon, crossfade no mobile):
     slide ativo = [data-mm-active]; no desktop os slides ficam lado a lado e o scroller rola.
     Autoplay a cada N s; pontos (role=tab), pausar/tocar, swipe no mobile. Enquanto a higiene
     do section_kit estiver ativa (style[data-cl-freeze]) o hero fica parado no slide 0, como o
     pin que o kit aplica ao componente do concorrente. */
  function initHero(ss){
    if (ss.__clHero) return; ss.__clHero = true;
    var sc = ss.querySelector('cl-slideshow-slides'); if (!sc) return;
    var slides = [].slice.call(sc.children).filter(function(c){ return c.tagName === 'CL-SLIDESHOW-SLIDE'; });
    if (slides.length < 2) return;
    var dots = [].slice.call(ss.querySelectorAll('.slideshow-controls__dots [role="tab"], cl-slideshow-controls [role="tab"]'));
    var pauseB = ss.querySelector('.clx-icon-pause'), playB = ss.querySelector('.clx-icon-play');
    var cur = 0, timer = null, paused = false, secs = parseFloat(ss.getAttribute('autoplay')) || 6;
    function frozen(){ return !!document.querySelector('style[data-cl-freeze]'); }
    function go(i){
      cur = (i + slides.length) % slides.length;
      slides.forEach(function(s, k){ s.toggleAttribute('data-mm-active', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
      dots.forEach(function(d, k){ d.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
      if (sc.scrollWidth > sc.clientWidth + 1) sc.scrollTo({left: slides[cur].offsetLeft - slides[0].offsetLeft, behavior: 'auto'});
    }
    function tick(){
      if (frozen()) { if (cur !== 0 && !ss.__clTouched) go(0); return; }
      if (!paused) go(cur + 1);
    }
    function start(){ clearInterval(timer); timer = setInterval(tick, secs * 1000); }
    dots.forEach(function(d, k){ d.addEventListener('click', function(e){ e.preventDefault(); ss.__clTouched = true; go(k); start(); }); });
    if (pauseB) pauseB.addEventListener('click', function(e){ e.preventDefault(); paused = true; ss.setAttribute('paused', ''); });
    if (playB) playB.addEventListener('click', function(e){ e.preventDefault(); paused = false; ss.removeAttribute('paused'); });
    var x0 = 0, y0 = 0, tr = false, hz = false, mq = window.matchMedia('(max-width: 749px)');
    sc.addEventListener('pointerdown', function(e){ if (!mq.matches || e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; tr = true; hz = false; }, {passive: true});
    sc.addEventListener('pointermove', function(e){
      if (!tr) return; var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!hz && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) hz = true;
      if (hz && e.cancelable) e.preventDefault();
    }, {passive: false});
    function end(e){ if (!tr) return; tr = false; var dx = e.clientX - x0; if (hz && Math.abs(dx) >= 50) { ss.__clTouched = true; go(cur + (dx < 0 ? 1 : -1)); start(); } }
    sc.addEventListener('pointerup', end); sc.addEventListener('pointercancel', end);
    go(0); start();
  }

  /* grade de produtos abaixo do main-product (recomendacoes): o carrossel externo do Fabric veio
     SEM setas (as do extract sao das galerias dos cards). Operador (2026-09-28): seta no desktop,
     so toque no mobile. O toque e o scroll nativo (overflow-x + snap); no desktop as setas rolam
     1 card e o mouse tambem arrasta. */
  var REC = 'cl-product-recommendations cl-slideshow-component.resource-list__carousel';
  var ARROW = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="20" height="20"><path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>';
  function recsCss(){
    if (document.getElementById('cl-recs-css')) return;
    var st = document.createElement('style'); st.id = 'cl-recs-css';
    st.textContent =
      REC + '{position:relative}' +
      '.cl-rec-arrow{position:absolute;z-index:3;top:var(--cl-rec-y,40%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;' +
        'display:flex;align-items:center;justify-content:center;padding:0;margin:0;border:1px solid rgba(0,0,0,.12);background:#fff;color:#000;' +
        'box-shadow:0 2px 8px rgba(0,0,0,.12);cursor:pointer;transition:opacity .2s}' +
      '.cl-rec-arrow--prev{left:16px}.cl-rec-arrow--prev svg{transform:scaleX(-1)}.cl-rec-arrow--next{right:16px}' +
      '.cl-rec-arrow[disabled]{opacity:0;pointer-events:none}' +
      REC + '[data-cl-fits] .cl-rec-arrow{display:none}' +
      '@media screen and (max-width:749px){.cl-rec-arrow{display:none!important}}' +
      '@media screen and (min-width:750px){' + REC + ' cl-slideshow-slides.cl-dragging{cursor:grabbing;scroll-snap-type:none!important;user-select:none}}';
    document.head.appendChild(st);
  }
  function initRec(ss){
    if (ss.__clRec) return; ss.__clRec = true;
    var sc = ss.querySelector(':scope > cl-slideshow-container > cl-slideshow-slides'); if (!sc) return;
    function slides(){ return [].slice.call(sc.children).filter(function(c){ return c.tagName === 'CL-SLIDESHOW-SLIDE'; }); }
    function step(){ var s = slides(); return s[0] ? s[0].getBoundingClientRect().width : sc.clientWidth; }
    function mk(dir){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cl-rec-arrow cl-rec-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next'); b.innerHTML = ARROW;
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var max = sc.scrollWidth - sc.clientWidth;
        sc.scrollTo({left: Math.max(0, Math.min(max, sc.scrollLeft + (dir === 'prev' ? -1 : 1) * step())), behavior: 'smooth'});
      });
      ss.appendChild(b); return b;
    }
    var prev = mk('prev'), next = mk('next');
    function upd(){
      var max = sc.scrollWidth - sc.clientWidth;
      if (max <= 2) ss.setAttribute('data-cl-fits', ''); else ss.removeAttribute('data-cl-fits');
      prev.disabled = sc.scrollLeft <= 2; next.disabled = sc.scrollLeft >= max - 2;
      // setas no meio da FOTO do card (nao do card inteiro com titulo/preco)
      var im = sc.querySelector('img'), r0 = ss.getBoundingClientRect();
      if (im) { var r = im.getBoundingClientRect(); if (r.height) ss.style.setProperty('--cl-rec-y', Math.round(r.top - r0.top + r.height / 2) + 'px'); }
    }
    sc.addEventListener('scroll', upd, {passive: true});
    window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();
    // mouse arrasta no desktop (o toque ja rola nativo)
    var down = false, x0 = 0, l0 = 0, moved = false;
    sc.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; x0 = e.clientX; l0 = sc.scrollLeft;
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) { moved = true; sc.classList.add('cl-dragging'); }
      sc.scrollTo({left: l0 - dx, behavior: 'instant'});
    });
    window.addEventListener('pointerup', function(){
      if (!down) return; down = false;
      if (!moved) return;
      sc.classList.remove('cl-dragging');
      var w = step();
      sc.scrollTo({left: Math.round(sc.scrollLeft / (w || 1)) * w, behavior: 'smooth'});
      setTimeout(function(){ moved = false; }, 0);
    });
    // arrastar nao pode virar clique no card
    sc.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    sc.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }
  function initRecs(){
    var list = document.querySelectorAll(REC); if (!list.length) return;
    recsCss();
    [].forEach.call(list, initRec);
  }

  function boot(){
    accState(); fitSwatches(); watchHeader(); initRecs();
    document.querySelectorAll('cl-slideshow-component[autoplay]').forEach(function(ss){ if (ss.closest(SEC)) initHero(ss); });
    document.querySelectorAll('cl-slideshow-component').forEach(function(ss){ if (ss.closest(SEC) && !ss.hasAttribute('autoplay')) initSlideshow(ss); });
  }
  window.addEventListener('resize', function(){ accState(); fitSwatches(); });
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.clInteractiveBoot = boot;
})();
